import { FeedbackQuestion } from "~skillBuilder/components";

export const CEFeedback = [
  // Feedback Question 1
  {
    attribute: "classroom-engagement/feedback",
    label: "Was the Classroom Engagement content helpful?",
    answerType: {
      type: "CHOICE",
      options: [
        { label: "Yes", value: "yes", icon: { name: "Thumb Up", color: "black" } },
        { label: "No", value: "no", icon: { name: "Thumb Down", color: "black" } },
      ],
    },
    isRequired: true,
  },
  // Feedback Question 2
  {
    attribute: "classroom-engagement/comments",
    label: "Tell us more of what you'd like to see (optional)",
    answerType: {
      type: "TEXT",
      placeholder: "Response",
    },
  },
] as const satisfies Array<FeedbackQuestion>;
